import React, {useEffect, useState} from 'react';
import {styles} from "../styles";
import {Microscope} from "../../../assets";
import {getMainActivity, MainActivityType, MainActivityCardType} from "../../../axios/api";

const MainActivity = () => {
    const [data, setData] = useState<MainActivityCardType[] | null>(null)
    useEffect(() => {
        getMainActivity().then(setInfo).catch(console.error);
    }, []);

    const setInfo = (d: MainActivityType) => {
        setData(d.results)
    }

    return (
        <div className={styles.container}>
            <h2 className={styles.title}><img src={Microscope}/>Основной вид деятельности</h2>
            {data?.map((item) => <div key={item.id} className={styles.content}>
                <div className={styles.text} dangerouslySetInnerHTML={{__html: item.text}}></div>
                <img className={styles.image}
                     src={item.image}/>
            </div>)
            }

        </div>
    )
}

export {MainActivity};